import { defineStore } from 'pinia';
import { NotificationsItemType } from '@/types';

const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    notifications: [] as NotificationsItemType[],
  }),
  actions: {
    add(notification: NotificationsItemType) {
      this.notifications.push(notification);
    },

    remove(index: number) {
      this.notifications.splice(index, 1);
    },
  },
});

export default useNotificationsStore;
